import useBreakpoint from '@/hooks/useBreakpoint';
import BreadcrumbPaginaMobile from './Designs/Mobile';
import BreadcrumbPaginaDesktop from './Designs/Desktop';
import { CSSProperties } from 'react';
import { BreadcrumbLink } from '../Breadcrumbs';

export type BreadcrumbPaginaProps = {
  $nomePaginaAtual: string;
  style?: CSSProperties;
  $linkDefault?: BreadcrumbLink;
};

export default function BreadcrumbPagina(props: BreadcrumbPaginaProps) {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? (
    <BreadcrumbPaginaMobile {...props} />
  ) : (
    <BreadcrumbPaginaDesktop {...props} />
  );
}
